// extracted by mini-css-extract-plugin
export default {"empty":"TransactionMobile_empty__ah+Qy"};